export const ImageIcons = () => (
  <svg width="80" height="33" viewBox="0 0 80 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.9556 23.4503L7.48534 26.8014C5.70363 27.1639 4.2056 25.4477 4.80558 23.7313L7.26688 16.6902C7.3318 16.5044 7.41984 16.3276 7.52893 16.1639L11.8315 9.7068C12.1747 9.19172 12.7077 8.83332 13.3142 8.70981L23.1633 6.70416C24.6269 6.40612 25.9921 7.53478 25.9746 9.02828L25.8319 21.1811C25.819 22.285 25.0374 23.2302 23.9556 23.4503ZM24.1248 21.5428L18.118 22.765L17.5947 20.505L13.8812 21.2606L13.2964 23.746L9.84469 24.4483L13.6834 10.5054L17.6426 9.69989L21.0542 21.3372L21.2 8.97607L24.2806 8.3493L24.1248 21.5428ZM15.8301 12.622L15.7996 12.6282C15.511 14.1283 15.1833 15.7482 14.8176 17.264L14.5947 18.2151L16.9526 17.7353L16.7452 16.8718C16.417 15.4972 16.0992 14.0086 15.8319 12.6216L15.8301 12.622Z"
      fill="black"
      fillOpacity="0.8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.1182 22.7647L24.1251 21.5426L24.2808 8.34905L21.2003 8.97583L21.0544 21.3369L17.6428 9.69965L13.6837 10.5052L9.84495 24.4481L13.2966 23.7458L13.8814 21.2603L17.5949 20.5048L18.1182 22.7647ZM15.7999 12.6279L15.8304 12.6217L15.8321 12.6214C16.0994 14.0084 16.4172 15.497 16.7455 16.8716L16.9529 17.7351L14.595 18.2148L14.8179 17.2638C15.1836 15.748 15.5113 14.128 15.7999 12.6279Z"
      fill="#FF4C55"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.9556 23.4503L7.48534 26.8014C5.70363 27.1639 4.2056 25.4477 4.80558 23.7313L7.26688 16.6902C7.3318 16.5044 7.41984 16.3276 7.52893 16.1639L11.8315 9.7068C12.1747 9.19172 12.7077 8.83332 13.3142 8.70981L23.1633 6.70416C24.6269 6.40612 25.9921 7.53478 25.9746 9.02828L25.8319 21.1811C25.819 22.285 25.0374 23.2302 23.9556 23.4503ZM12.4816 10.14C12.7104 9.79662 13.0658 9.55768 13.4701 9.47535L23.3192 7.4697C24.2949 7.27101 25.205 8.02344 25.1934 9.01911L25.0507 21.1719C25.0421 21.9078 24.5211 22.538 23.7999 22.6847L7.32958 26.0358C6.14177 26.2775 5.14308 25.1334 5.54307 23.9891L8.00437 16.9479C8.04765 16.8241 8.10635 16.7063 8.17907 16.5971L12.4816 10.14Z"
      fill="#2FA8FF"
    />
    <g filter="url(#filter0_bd_3132_112368)">
      <mask id="path-5-inside-1_3132_112368" fill="white">
        <path d="M31.1904 4.0614H49.1904V22.0614H31.1904V4.0614Z" />
      </mask>
      <path d="M31.1904 4.0614H49.1904V22.0614H31.1904V4.0614Z" fill="white" shapeRendering="crispEdges" />
      <path
        d="M31.1904 4.0614V2.5614C30.362 2.5614 29.6904 3.23297 29.6904 4.0614H31.1904ZM49.1904 4.0614H50.6904C50.6904 3.23297 50.0189 2.5614 49.1904 2.5614V4.0614ZM49.1904 22.0614V23.5614C50.0189 23.5614 50.6904 22.8898 50.6904 22.0614H49.1904ZM31.1904 22.0614H29.6904C29.6904 22.8898 30.362 23.5614 31.1904 23.5614V22.0614ZM31.1904 5.5614H49.1904V2.5614H31.1904V5.5614ZM47.6904 4.0614V22.0614H50.6904V4.0614H47.6904ZM49.1904 20.5614H31.1904V23.5614H49.1904V20.5614ZM32.6904 22.0614V4.0614H29.6904V22.0614H32.6904Z"
        fill="white"
        mask="url(#path-5-inside-1_3132_112368)"
      />
      <path d="M48.2162 5.03577V21.0869H32.165L48.2162 5.03577Z" fill="url(#paint0_linear_3132_112368)" />
      <path d="M32.1646 21.087V5.03586H48.2158L32.1646 21.087Z" fill="url(#paint1_linear_3132_112368)" />
    </g>
    <g filter="url(#filter1_di_3132_112368)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M66.3477 14.8487C66.3846 14.8132 66.421 14.777 66.4568 14.7402C66.494 14.7927 66.5328 14.8442 66.573 14.8946L66.3477 14.8487ZM57.5258 21.2699C57.5357 21.272 57.5455 21.274 57.5554 21.276C57.5652 21.278 57.5751 21.28 57.5849 21.282L69.3717 23.68C69.3814 23.682 69.3912 23.6841 69.401 23.686C69.4108 23.688 69.4206 23.69 69.4304 23.6919L69.7776 23.7626L69.7805 23.7487C72.4144 24.0841 74.9006 22.3339 75.4385 19.6899C75.935 17.2496 74.6063 14.8617 72.3893 13.9418C72.4457 13.7865 72.4913 13.6252 72.5252 13.4585C72.8974 11.6294 71.7163 9.84496 69.8872 9.47283C69.0111 9.29458 68.1452 9.47269 67.4399 9.90768C66.8959 8.50411 65.6708 7.39818 64.0861 7.07579C61.6117 6.57235 59.1976 8.17019 58.6941 10.6447C58.67 10.7635 58.6506 10.8822 58.636 11.0005C56.1992 10.9762 54.0086 12.6792 53.5047 15.1561C52.9495 17.8851 54.646 20.5494 57.3191 21.2223L57.3181 21.2277L57.5258 21.2699Z"
        fill="url(#paint2_linear_3132_112368)"
      />
    </g>
    <g filter="url(#filter2_d_3132_112368)">
      <path
        d="M70.6118 20.2244L65.2779 11.6713L56.9038 17.4355L60.6395 18.1956C60.539 19.8097 60.7157 24.6999 61.8668 28.4392C64.775 24.4613 66.026 22.4026 67.1848 19.5272L70.6118 20.2244Z"
        fill="url(#paint3_linear_3132_112368)"
      />
      <path
        d="M60.889 18.2111L60.9025 17.994L60.6893 17.9506L57.5302 17.3078L65.2042 12.0255L70.0921 19.8636L67.2346 19.2822L67.0307 19.2407L66.9529 19.4337C65.8456 22.1815 64.6547 24.1768 61.9639 27.8815C60.9512 24.2508 60.7941 19.7358 60.889 18.2111Z"
        stroke="url(#paint4_linear_3132_112368)"
        strokeOpacity="0.4"
        strokeWidth="0.5"
      />
    </g>
    <defs>
      <filter
        id="filter0_bd_3132_112368"
        x="25.9981"
        y="-1.13091"
        width="28.3846"
        height="28.3846"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="2.59615" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_3132_112368" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" />
        <feBlend mode="normal" in2="effect1_backgroundBlur_3132_112368" result="effect2_dropShadow_3132_112368" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_3132_112368" result="shape" />
      </filter>
      <filter
        id="filter1_di_3132_112368"
        x="51.3994"
        y="5.98315"
        width="26.1426"
        height="20.8066"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3132_112368" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3132_112368" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="0.5" dy="0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0" />
        <feBlend mode="normal" in2="shape" result="effect2_innerShadow_3132_112368" />
      </filter>
      <filter
        id="filter2_d_3132_112368"
        x="54.9033"
        y="10.6713"
        width="17.708"
        height="20.7679"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3132_112368" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3132_112368" result="shape" />
      </filter>
      <linearGradient
        id="paint0_linear_3132_112368"
        x1="40.5919"
        y1="11.0914"
        x2="44.2034"
        y2="21.5977"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF6D00" />
        <stop offset="1" stopColor="#F8EF6F" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3132_112368"
        x1="32.1646"
        y1="9.44994"
        x2="40.9563"
        y2="12.2954"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#47FF65" />
        <stop offset="1" stopColor="#2C99FF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3132_112368"
        x1="66.3107"
        y1="8.38344"
        x2="63.444"
        y2="22.4738"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#83E1FF" />
        <stop offset="1" stopColor="#0074C7" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3132_112368"
        x1="62.2594"
        y1="28.5191"
        x2="65.0366"
        y2="14.8687"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CE00AD" />
        <stop offset="1" stopColor="#FFC700" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_3132_112368"
        x1="59.9331"
        y1="14.5892"
        x2="66.6352"
        y2="28.2206"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
)
